// Version : 0.0.1
// Author : AGALYA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:01-08-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD FUNDER DETAILS START *********************** */
export const funderDetailsAdd = (addData: any) => {
	const data = {
		AddFunderDetailsToken: addData,
	};
	const url = `${API_URL}addFunderDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD FUNDER DETAILS END *********************** */

/** ***************** UPDATE FUNDER DETAILS START *********************** */
export const funderDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateFunderDetailsToken: updateData,
	};
	const url = `${API_URL}updateFunderDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE FUNDER DETAILS END *********************** */

/** ***************** GET FUNDER LIST START *********************** */
export const funderListGet = (listData: any) => {
	const data = {
		GetFunderListToken: listData,
	};
	const url = `${API_URL}getFunderList`;
	return makeApiCall(url, data);
};
/** ***************** GET FUNDER LIST END *********************** */

/** ***************** FETCH FUNDER DETAILS START *********************** */
export const funderDetailsFetch = (fetchData: any) => {
	const data = {
		FetchFunderDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchFunderDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH FUNDER DETAILS END *********************** */

/** ***************** DELETE FUNDER DETAILS START *********************** */
export const funderDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteFunderDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteFunderDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE FUNDER DETAILS END *********************** */

/** ***************** UPDATE FUNDER PUBLISH STATUS START *********************** */
export const FunderPublishUpdate = (publishData: any) => {
	const data = {
		UpdateFunderPublishToken: publishData,
	};
	const url = `${API_URL}updatePublishStatusFunder`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE FUNDER PUBLISH STATUS END *********************** */
